import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import TestimonialView from '../views/user/TestimonialView.vue'
import ApprovedTestimonialsListView from '../views/admin/ApprovedTestimonialsListView.vue'
import PendingTestimonialsListView from '../views/admin/PendingTestimonialsListView.vue'
import RejectedTestimonialsListView from '../views/admin/RejectedTestimonialsListView.vue'
import SubscripstionsView from '@/views/admin/SubscriptionsView.vue';
import AdminDashboardView from '../views/admin/AdminDashboardView.vue'
import SlideShowView from '@/views/public/SlideShowView.vue'
import DetailsView from '@/views/public/DetailsView.vue'
import LoginView from '@/views/LoginView.vue'
import Login from '@/views/Login.vue'
import QRCodeDetails from '@/views/public/QRCodeView.vue'
import DashboardView from '@/views/public/DashboardView.vue'
import DashboardRaffleView from '@/views/public/DashboardRaffleView.vue'
import RegistrationView from '@/views/RegistrationView.vue';
//Voting
import VotingSubscriptionsView from '@/views/admin/voting/VotingSubscriptionsView.vue'
import NewVotingSubscriptionView from '@/views/admin/voting/NewVotingSubscriptionView.vue'
import LandingPageView from '@/views/public/LandingPageView.vue'
import EventRegistration from '@/views/event-registration/EventRegistration.vue'
import EventRegistrationDetails from '@/views/event-registration/EventRegistrationDetails.vue'
import EventAttendanceDetails from '@/views/event-registration/EventAttendanceDetails.vue'
import PassportMainPage from '@/views/event-registration/PassportMainPage.vue'
import ExhibitorRegistration from '@/views/event-registration/ExhibitorRegistration.vue'
import EventRegistrationComplete from '@/views/event-registration/EventRegistrationComplete.vue'

Vue.use(VueRouter)

const routes = [
  {
    path : '/',
    name : 'PassportMainPage',
    component : PassportMainPage
  },
  {
    path : '/event/register',
    name : 'EventRegistration',
    component : EventRegistration
  },
  {
    path : '/event/exhibitor-registration',
    name : 'ExhibitorRegistration',
    component : ExhibitorRegistration
  },
  {
    path : '/event/register/:code',
    name : 'EventRegistrationDetails',
    component : EventRegistrationDetails
  },
  {
    path : '/event/register/:code/success',
    name : 'EventRegistrationComplete',
    component : EventRegistrationComplete
  },
  {
    path : '/event/attendance/:code',
    name : 'EventAttendanceDetails',
    component : EventAttendanceDetails
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.isLoggedIn) {
      next({ name: 'Login' })
    } else {
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth, make sure to always call next()!
  }
})

export default router
